import React from 'react';

const RoundImg = ({
  src,
  srcWebp,
  className,
  style,
  width,
  height,
  alt = 'CrossFit Varna Img',
}) => (
  <picture>
    {srcWebp && <source srcSet={srcWebp} type="image/webp" />}
    <source srcSet={src} type="image/jpeg" />
    <img
      src={src}
      alt={alt}
      className={`u-img-responsive u-img-round u-object-fit ${className}`}
      width={width}
      height={height}
      style={style}
    />
  </picture>
);

export default RoundImg;
